<template>
  <div class="cosmic" aria-hidden="true">
    <div class="cosmic__sky"></div>
    <div class="cosmic__stars"></div>
    <div class="cosmic__aurora"></div>
    <span class="cosmic__planet cosmic__planet--a"></span>
    <span class="cosmic__planet cosmic__planet--b"></span>
    <span class="cosmic__planet cosmic__planet--c"></span>
  </div>
</template>

<script>
export default { name: "CosmicBackground" };
</script>

<style scoped>
/* 버츄펫 우주 배경 — 404·온보딩 공용. 부모는 position:relative, 콘텐츠는 z-index 위로. */
.cosmic {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
  /* 깊은 인디고→바이올렛→흑자색 (보라-on-화이트 클리셰 회피) */
  background: radial-gradient(ellipse 120% 90% at 50% -10%, #3a2780 0%, #1d1450 38%, #0c0822 78%, #07050f 100%);
}

.cosmic__sky {
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(1px 1px at 12% 22%, #ffffffcc, transparent),
    radial-gradient(1px 1px at 28% 64%, #ffffff99, transparent),
    radial-gradient(1.6px 1.6px at 47% 18%, #fff, transparent),
    radial-gradient(1px 1px at 63% 51%, #ffffffaa, transparent),
    radial-gradient(1.4px 1.4px at 78% 30%, #d9c8ff, transparent),
    radial-gradient(1px 1px at 88% 72%, #ffffff88, transparent),
    radial-gradient(1.2px 1.2px at 35% 84%, #ffffffaa, transparent),
    radial-gradient(1px 1px at 56% 88%, #ffffff77, transparent),
    radial-gradient(1.6px 1.6px at 8% 80%, #c9b6ff, transparent),
    radial-gradient(1px 1px at 92% 14%, #ffffffaa, transparent);
  background-repeat: no-repeat;
}
.cosmic__stars {
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(1.5px 1.5px at 20% 40%, #fff, transparent),
    radial-gradient(2px 2px at 70% 25%, #fff, transparent),
    radial-gradient(1.5px 1.5px at 40% 70%, #fff, transparent),
    radial-gradient(2px 2px at 85% 55%, #fff, transparent);
  background-repeat: no-repeat;
  animation: cosmic-twinkle 3.4s ease-in-out infinite;
}
.cosmic__aurora {
  position: absolute;
  top: -30%;
  left: 50%;
  width: 90%;
  height: 70%;
  transform: translateX(-50%);
  background: radial-gradient(ellipse at center, rgba(149, 85, 253, 0.35), rgba(255, 110, 174, 0.12) 45%, transparent 70%);
  filter: blur(40px);
}

.cosmic__planet {
  position: absolute;
  border-radius: 50%;
  filter: drop-shadow(0 0 24px currentColor);
}
.cosmic__planet--a {
  width: 90px;
  height: 90px;
  top: 16%;
  left: 10%;
  color: #7c5cff;
  background: radial-gradient(circle at 32% 28%, #c9b8ff, #6a4bff 60%, #3a258a);
  animation: cosmic-float 9s ease-in-out infinite;
}
.cosmic__planet--b {
  width: 52px;
  height: 52px;
  bottom: 16%;
  right: 12%;
  color: #ff7eb3;
  background: radial-gradient(circle at 35% 30%, #ffd1e6, #ff6fae 60%, #c43c7e);
  animation: cosmic-float 7s ease-in-out infinite reverse;
}
.cosmic__planet--c {
  width: 28px;
  height: 28px;
  top: 22%;
  right: 18%;
  color: #ffd36b;
  background: radial-gradient(circle at 35% 30%, #fff0c9, #ffc24b 60%, #d18a1f);
  animation: cosmic-float 11s ease-in-out infinite;
}

@keyframes cosmic-twinkle {
  0%, 100% { opacity: 0.35; }
  50% { opacity: 1; }
}
@keyframes cosmic-float {
  0%, 100% { transform: translateY(0) translateX(0); }
  50% { transform: translateY(-22px) translateX(10px); }
}

@media (prefers-reduced-motion: reduce) {
  .cosmic * { animation: none !important; }
}
</style>
